import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {BlogState} from '../state/blog.state';
import {LoadList} from '../state/blog.actions';
import {FADE_IN} from '../../../shared/animations';
import { GeneralHeaderComponent } from '../../../layout/header/components/general-header/general-header.component';
import { RtLoadingComponent } from '../../../rt-loading/rt-loading/rt-loading.component';
import { ExploreYourBrainComponent } from '../../../shared/components/explore-your-brain/explore-your-brain.component';
import { FooterComponent } from '../../../layout/footer/footer.component';
import { AsyncPipe, DatePipe } from '@angular/common';


@Component({
    selector: 'app-blog-list',
    templateUrl: './blog-list.component.html',
    styleUrls: ['./blog-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN],
    imports: [GeneralHeaderComponent, RtLoadingComponent, RouterLink, ExploreYourBrainComponent, FooterComponent, AsyncPipe, DatePipe]
})
export class BlogListComponent implements OnInit, OnDestroy {

  public readonly list$ = this.store.select(BlogState.list);
  public readonly loading$ = this.store.select(BlogState.loading);
  public readonly listHeader$ = this.store.select(BlogState.listHeader);

  private subscription = new Subscription();

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private title: Title,
  ) {
  }

  ngOnInit() {
    this.subscription = this.route.params.pipe(
      filter(x => x.name && x.value),
    ).subscribe(
      ({name, value}) => this.store.dispatch(new LoadList(name, value))
    );
    this.listHeader$.subscribe(header => this.title.setTitle(`${header} | BrainKey`));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
